import React from "react";
import FormFields from "./FormFields";

const FormFieldsWrapper = (props) => {
  const { isImportant = false, title = "" } = props;
  // console.log(props, " field data");

  return (
    <>
      <FormFields
        {...props}
        {...(props.checkType
          ? props.checkType(props?.FormikForm?.values)
          : { type: props.type })}
      />
      {/* <Typography variant='body2' sx={{
          fontSize: "0.75rem",
          opacity: 0.7
        }}
      >
        {isImportant && `The ${title} field is a valuable addition`}
      </Typography> */}
    </>
  );
};

export default FormFieldsWrapper;
